export default __webpack_public_path__ + "static/media/photo3.2f703c02.jpg";